<template>
  <div v-if="this.record">
    <h4>
      Single Case Reassignment
      <v-icon
        color="rgba(21, 102, 124, 0.9)"
        @click="
						newAssignStatus = null
						newStaffId = null
						showStaffSelect = false
						comment = ''
            $emit('close');
            dialog = false;
          "
        style="float: right"
        >mdi-close</v-icon
      >
    </h4>
		<v-divider></v-divider>
		<!-- <h5>{{ this.record.assignStatus }} ({{ this.assignStaffId }})</h5> -->
		<h5>{{ this.record.assignStatus }} ({{ this.record.staffId }})</h5>
		<!-- <p>{{ this.record }}</p> -->
		<p>{{ this.record.dwellingId }}</p>
    <div v-if="this.record.assignStatus !== 'CONFIRMED'">
      <!-- <p>Current Status: {{ this.record.assignStatus }}</p>
      <p>Current Assigned Staff: {{ this.assignStaffId }}</p> -->

      <!-- <v-tooltip top max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <p v-bind="attrs" v-on="on">
            <strong> Add Comments Or Change Status </strong>
          </p>
        </template>
        <span
          >Status value is not required to add comments for an address. Only
          select status value from list when manual status change is required
          for an address.</span
        >
      </v-tooltip> -->
      <v-select
        :items="newStatusOptionsList"
        item-text="regular"
        item-value="capitalized"
        v-model="newAssignStatus"
        label="New Status"
        required
				density="compact"
      ></v-select>
			<v-select
        :items="staffIds"
        v-model="newStaffId"
        label="New Assigned Staff"
        required
				density="compact"
				v-if="showStaffSelect"
      ></v-select>
      <v-textarea
        v-model="comment"
        label="Comments (optional)"
        rows="2"
        row-height="20"
        outlined
				density="compact"
      ></v-textarea>
			<!-- <v-textarea
        v-model="comment"
        label="Comments (optional)"
        rows="2"
        row-height="20"
        outlined
				v-if="newAssignStatus"
      ></v-textarea> -->
      <!-- <p class="list-group-item-text" align="right">
        <v-btn
          id="cancelButton"
          x-small
          @click="
						newAssignStatus = null
						newStaffId = null
						showStaffSelect = false
            $emit('close');
            dialog = false;
          "
        >
          Cancel
        </v-btn>
        <v-btn
          id="submitButton"
          x-small
          @click="
            updateCase();
            $emit('close');
            dialog = false;
          "
          :disabled="isDisabled"
        >
          Submit
        </v-btn>
      </p> -->
			<v-divider></v-divider>
	<v-btn
				id="submitButton"
        small
        @click="
          updateCase();
          $emit('close');
          dialog = false;
        "
				:disabled="isDisabled"
      >
        Submit
      </v-btn>
    </div>
    <div v-else>
      <!-- <p>Current Status: {{ this.record.assignStatus }}</p>
      <p>Current Assigned Staff: {{ this.assignStaffId }}</p> -->
      <!-- <v-divider></v-divider> -->
      <!-- <p>
        <strong>Cannot Add Comments Or Change Status </strong>
      </p> -->
			<p align="center"><v-icon color="red">mdi-close-circle-outline</v-icon>Cannot Change</p>
    </div>
  </div>
</template>
<script>

import { caseAssignmentService } from "../services/caseAssignmentService";
import { STORE_CONSTANTS } from "@/common/store.constants";

import { mapGetters } from "vuex";

export default {
  name: "StatusPopup",
  props: {
    studyCode: String,
    record: Object,
    assignStaffId: String,
    region: String
  },
  data: () => ({
    STORE_CONSTANTS,
    comment: "",
    newStaffId: null,
    oldStaffId: null,
    newStatusOptionsList: [],
    startingStatus: "",
    startingStaff: "",
    newAssignStatus: null,
		showStaffSelect: null
  }),
  watch: {
    record: function (newValue, oldValue) {
      const me = this;
      // console.log("cht this.record.assignStatus: ", this.record.assignStatus);
      if (this.record.assignStatus === "NOTREVIEWED" || this.record.assignStatus === "NOT_REVIEWED") {
        me.newStatusOptionsList = [
          { regular: "Unassigned", capitalized: "UNASSIGNED" },
					{ regular: "Assigned", capitalized: "ASSIGNED" }
					// { regular: "Confirmed", capitalized: "CONFIRMED" }
        ];
      }
      if (this.record.assignStatus === "ASSIGNED") {
        me.newStatusOptionsList = [
          { regular: "Unassigned", capitalized: "UNASSIGNED" }
          // { regular: "Not Reviewed", capitalized: "NOT_REVIEWED" },
          // { regular: "Assigned", capitalized: "ASSIGNED" }
        ];
      }
      if (this.record.assignStatus === "UNASSIGNED") {
        me.newStatusOptionsList = [{ regular: "Assigned", capitalized: "ASSIGNED" }];
      }
    },
		newAssignStatus: function (newValue, oldVAlue) {
			// console.log("newValue: ", newValue)
			const me = this;
			if (newValue === "ASSIGNED") {
				// users include all users in region except ‘Unassigned’
				me.showStaffSelect = true
				me.newStaffId = null
			}
			if (newValue === "UNASSIGNED") {
				// do not show New Assigned Staff option, default to  ‘Unassigned’
				me.showStaffSelect = false
				me.newStaffId = "Unassigned"
				console.log('me.newStaffId', me.newStaffId)
			}
			if (newValue === "NOT_REVIEWED") {
				// do not show New Assigned Staff option, default to selected FI
				me.showStaffSelect = false
				me.newStaffId = me.startingStaff
			}
			if (newValue === "CONFIRMED") {
				// do not show New Assigned Staff option
				me.showStaffSelect = false
				me.newStaffId = me.startingStaff
			}
		}
  },
  updated () {
    if (this.record) {
      this.startingStatus = this.record.assignStatus;
      this.startingStaff = this.record.staffId;
    }
  },
  computed: {
    isDisabled () {
			// submit button disabled if newAssignStatus and newStaffId are not values or th
			let disabled = true;
			if (this.newAssignStatus && this.newStaffId) {
				disabled = false
			}
			if (this.comment.length > 0 && ((this.newAssignStatus && this.newStaffId) || (!this.newAssignStatus && !this.newStaffId))) {
				disabled = false
			}
			return disabled
    },
    staffIds () {
      const regionStaffIds = this.getRegionStaff;
      // console.log('Staff IDs:');
      // console.log(regionStaffIds);
      return regionStaffIds;
    },
    ...mapGetters("assignment", [
        "getRegionStaff"
    ]),
  },
  methods: {
    updateCase () {
      const me = this;
      if (this.record) {
        let studyCodeTmp = me.studyCode;
        let caseUuidTmp = this.record.caseUUID;
        console.log(this.record);
        let newStaffIdTmp = this.newStaffId;
      	let assignStatusTmp = this.newAssignStatus;
        let commentTmp = this.comment || "";
				let oldStaffIdTmp = this.record.staffId
        // let oldStaffIdTmp = this.assignStaffId;
        let updateCaseObject = {
          caseUuid: caseUuidTmp,
          assignStatus: assignStatusTmp,
          newStaffId: newStaffIdTmp,
          comment: commentTmp,
          oldStaffId: oldStaffIdTmp
        };

        me.$store.commit(this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_IS_LOADING, { data: true });
        // console.log("updateCaseObject: ", updateCaseObject)
        console.log("region on update case: ", this.region);
        caseAssignmentService
          .updateCaseBatch(studyCodeTmp, [updateCaseObject], this.region)
          .then(function (response) {
            if (response && response.data) {
              me.$emit("refreshData", response.data);
              // console.log('responseData: ', response.data)
            }
            me.startingStatus = me.newAssignStatus = "";
            me.startingStaff = me.newStaffId = "";
            me.comment = "";
            // console.log("case assignment update analysis called");
          })
          .catch(function (e) {
            console.log(e);
            me.$store.commit(this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_IS_LOADING, { data: false });
            me.startingStatus = me.newAssignStatus = "";
            me.startingStaff = me.newStaffId = "";
            me.comment = "";
          });
      }
    },
  },
};
</script>

<style scoped>
.list-group-item-text {
  margin-bottom: 0;
  line-height: 1;
}

#cancelButton {
  background-color: #f0ad4e;
  color: white;
}

#unassignButton {
  background-color: #642688;
  color: white;
}

#submitButton {
  background-color: #265a88;
  color: white;
}
.v-tooltip__content {
  background-color: rgb(21, 72, 124) !important;
  opacity: 1 !important;
}

.theme--light.v-divider {
  border-color: black;
}
</style>
